import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Placeholder visual for the Fase 2 action confirmation card. In Fase 1 no writes
 * exist — this component is kept in the module so the UI pattern is in place and
 * Luna can cover it in tests. It never triggers any backend call.
 */
@Component({
  selector: 'app-chat-action-card',
  templateUrl: './chat-action-card.component.html',
  styleUrls: ['./chat-action-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatActionCardComponent {
  @Input() toolName = '';
  @Input() summary = '';
}
